module.exports = "https://cdn.hellotech.com/client-assets/phones_and_tablets_desktop_36d877cbd1a3dfe9ebf72d12ec6065ce.webp";